import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import styles from './Card.module.scss';

const cn = withStyles(styles);

export type CardProps = {
  children: ReactNode;
  /** `container` = outer surface (24px radius), `section` = nested surface (16px radius). */
  variant?: 'container' | 'section';
  className?: string;
  'data-testid'?: string;
};

export default function Card({ children, variant = 'container', className, 'data-testid': testId }: CardProps) {
  return (
    <div className={[cn('card', variant), className].filter(Boolean).join(' ')} data-testid={testId}>
      {children}
    </div>
  );
}
